module.exports = __webpack_public_path__ + "static/media/36-12.a79997ac.mp3";